module.exports = __webpack_public_path__ + "static/media/co.156e6028.svg";